<div class="header__holder">
  <div class="col-md-4 header-left">
    <div class="header-menu open"
         [ngClass]="{ open: sendCloseMenu }"
         *ngIf="isAdminUser || isSfrsUser"
         (click)="toggleMenuClicked()">
      <div class="header-menu__holder">
        <span></span>
      </div>
    </div>
    <div class="header-title">
      <h2>HFSV Admin</h2>
    </div>
  </div>
  <div class="col-md-4 header-logo">
    <a routerLink="referral" class="header-logo__link" href="/">
      <img src="assets/images/crest-transparent.png" class="header-logo__image crest" alt="Scottish Fire & Rescue" />
      <img src="assets/images/sfrs-logo-white-on-black.png" class="header-logo__image logo" alt="Scottish Fire & Rescue" />
    </a>
  </div>
  <div class="col-md-4 header-right">
    <ul class="header-right__list">
      <li class="header-right__item">
        <button class="button--box blue login" *ngIf="!loggedIn" (click)="login()">
          Login
        </button>
      </li>
      <li class="header-right__item" *ngIf="userInitials">
        <div (click)="userMenuClicked()" class="header-right__login">
          {{ userInitials }}
        </div>
      </li>
    </ul>
  </div>
</div>
